module.exports = __webpack_public_path__ + "img/tech-spec.52039ee0.svg";